<template>
  <div>
  <!-- <div class="web-wrapper"> -->
    <!-- <img src="./assets/logo.png"> -->
    <navbar></navbar>
    <!-- <transition mode="out-in" name="pages"> -->
      <router-view/>
    <!-- </transition> -->
    <footerComponent>
    </footerComponent>
    <!-- </div> -->
    <!-- <back-to-top bottom="50px" right="30px">
      <span class="btn-to-top"><icon name="chevron-up" class="pulse animated"></icon>
      </span>
    </back-to-top>     -->
  </div>
</template>

<script>
import Navbar from './components/layout/navbar/navbar.vue';
import Footer from './components/layout/footer/footer.vue';
import widget from './mixins/widgets.js';
import BackToTop from 'vue-backtotop'

export default {
  components:{
    'navbar': Navbar,
    'footerComponent': Footer,
    BackToTop,
  },

  name: 'App',
  mixins:[widget],
  data(){
    return{

    }
  },

}
</script>

<style src="../node_modules/@mdi/font/css/materialdesignicons.min.css">
</style>

<style lang="scss" src="./scss/app.scss"></style>





// WEBPACK FOOTER //
// src/App.vue